var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.836 4.123 12 9.959 6.163 4.124a1.441 1.441 0 0 0-2.04 0l-.1.11a1.441 1.441 0 0 0 .1 1.93L9.959 12l-5.835 5.837a1.441 1.441 0 0 0 1.02 2.463l.141-.007c.329-.032.64-.176.879-.416L12 14.04l5.837 5.836a1.441 1.441 0 0 0 2.463-1.02l-.007-.14a1.437 1.437 0 0 0-.416-.88L14.04 12l5.837-5.837a1.443 1.443 0 0 0-2.041-2.04z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgIconClose;